import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export function Label({
  className,
  children,
  required,
  ...props
}: HTMLAttributes<HTMLLabelElement> & { htmlFor?: string; required?: boolean }) {
  return (
    <label className={cn('text-sm font-medium leading-none text-foreground', className)} {...props}>
      {children}
      {required && <span className="ms-0.5 text-destructive">*</span>}
    </label>
  );
}
